import axios from 'axios';

import { fetchPatrolsAccounts, fetchPatrolsAccountState } from '~/api/patrols';
import { patrolsActions } from '~/store/slices/patrolsSlice';

import type { AppAsyncThunk } from '~/store';
import type { IPatrolId } from '~/types/patrols';

export const getPatrolsAccountStateThunk =
  (signal?: AbortSignal): AppAsyncThunk =>
  async (dispatch) => {
    try {
      const response = await fetchPatrolsAccountState(signal);

      if (response?.timestamp) {
        dispatch(patrolsActions.setAccount(response));
      }
    } catch (error: unknown) {
      if (!axios.isCancel(error)) {
        console.error('Failed get patrols data', error);
      }
    }
  };

export const getPatrolsAccountsStateThunk =
  (patrols: IPatrolId[], signal?: AbortSignal): AppAsyncThunk =>
  async (dispatch) => {
    try {
      const response = await fetchPatrolsAccounts(patrols, signal);

      if (response?.timestamp) {
        dispatch(patrolsActions.setMembers(response));
      }
    } catch (error: unknown) {
      if (!axios.isCancel(error)) {
        console.error('Failed get patrols data', error);
      }
    }
  };
